import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SecuredResourceComponent } from '@app/shared/secured-resource/secured-resource.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ImagePreviewDialogModule } from '@app/shared/image-preview-dialog/image-preview-dialog.module';

@NgModule({
  declarations: [SecuredResourceComponent],
  imports: [
    CommonModule,
    MatProgressBarModule,
    MatProgressSpinner,
    MatIconModule,
    MatTooltipModule,
    MatDialogModule,
    TranslateModule,
    ImagePreviewDialogModule,
  ],
  exports: [SecuredResourceComponent],
})
export class SecuredResourceModule {}
